import type React from 'react';

import Loader from '@vlabs/shared/legacy-components/loader/Loader';
import type { FaceSampleProps } from '@vlabs/uikit';
import { FaceSample } from '@vlabs/uikit';

import { useGetFace } from '@vlabs/api/luna-api/client';
import { useGetCard } from '@vlabs/api/point-api/client';
import type { CardId } from '@vlabs/api/point-api/model';

interface CardSampleProps extends
  Omit<FaceSampleProps, 'src'> {
  cardId: CardId;
}

function CardSample({
  cardId,
  ...props
}: CardSampleProps): React.JSX.Element {
  const getCard = useGetCard(cardId, { targets: ['main_face_id'] });
  // @ts-expect-error enabled
  const getCardFace = useGetFace(getCard.data?.main_face_id, { targets: ['avatar'] }, {
    query: !!getCard.data?.main_face_id,
  });

  if (getCard.isLoading) return <Loader />;

  return (
    <FaceSample
      src={getCardFace.data?.avatar ? `/api/lp5${getCardFace.data.avatar}` : undefined}
      {...props}
    />
  );
}

export { CardSample };
